import { defineMessages } from 'react-intl'

const scope = `procurify.platform.iam.feature-sets.ReportAccessView.ReportAccessHeaderCard`

export default defineMessages({
  title: {
    id: `${scope}.title`,
    defaultMessage: 'Reports access settings',
  },
  description: {
    id: `${scope}.description`,
    defaultMessage:
      'This feature allows even more control over access to the spending reports. Users can be given access to see report information in specific {pluralSecondaryOrgCategoryLabel}.',
  },
  primaryCategorySelectLabel: {
    id: `${scope}.primaryCategorySelectLabel`,
    defaultMessage: '{singularPrimaryOrgCategoryLabel}',
  },
  allOptionLabel: {
    id: `${scope}.allOptionLabel`,
    defaultMessage: 'All',
  },
})
